<template>
    <div class="tw:flex tw:items-center tw:gap-2 tw:text-sm">
        <span class="tw:text-gray-700 tw:font-bold tw:hidden tw:md:block">Por página:</span>
        <BaseSelect
            id="per_page"
            :value="value"
            :options="options"
            @input="$emit('input', parseInt($event))"
            @change="$emit('change', parseInt($event))"
        />
    </div>
</template>

<script setup>
    import BaseSelect from '@/modules/admin/ui/BaseSelect.vue'

    defineProps({
        value: {
            type: Number,
            default: 5
        }
    })

    defineEmits(['input', 'change'])

    const options = [
        { value: 5, label: '5' },
        { value: 10, label: '10' },
        { value: 15, label: '15' },
        { value: 20, label: '20' }
    ]
</script>